import React, { useContext, useEffect, useState } from "react";
import { format, addDays, isSunday } from "date-fns";
import { FaHome, FaBriefcaseMedical, FaPlane } from "react-icons/fa";
import { Form, Modal } from "react-bootstrap";
import swal from "sweetalert";
import Select from "react-select";
import { BulkAttendanceHr } from "../Modal";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { Link } from "react-router-dom";
import {
  FiCalendar,
  FiChevronLeft,
  FiChevronRight,
  FiClock,
  FiCheck,
  FiUsers,
  FiFileText,
  FiSave,
  FiSearch,
  FiEye,
} from "react-icons/fi";
import "../Admin/AttendanceManagement.css";
const HalfDayClockIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    aria-hidden="true"
  >
    <path d="M12 3a9 9 0 0 0 0 18V3Z" fill="currentColor" opacity="0.3" />
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 7v5l3 2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AttandancecalendraHR = () => {
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const { password, username } = billpunchbasicauth;
  const [showcheckmodal, setshowcheckmodal] = useState(false);
  const [dates, setDates] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [firmHolidays, setFirmHolidays] = useState({ firmId: null, dates: {} });
  const firmId = user?.firm_id;
  const holidayDates = firmHolidays.firmId === firmId ? firmHolidays.dates : {};

  useEffect(() => {
    if (!firmId) return;
    const controller = new AbortController();
    const getHolidays = async () => {
      try {
        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmHoliday`,
          {
            method: "POST",
            headers: {
              Authorization: `Basic ${btoa(`${username}:${password}`)}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ firmid: firmId }),
            signal: controller.signal,
          },
        );
        if (!res.ok) throw new Error("Unable to fetch firm holidays");
        const data = await res.json();
        const mappedHolidays = {};
        if (data.status === "0" && Array.isArray(data.data)) {
          data.data.forEach((holiday) => {
            const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(
              holiday.datee?.trim(),
            );
            if (!match) return;
            const [, day, month, year] = match;
            const date = new Date(Number(year), Number(month) - 1, Number(day));
            if (
              date.getFullYear() !== Number(year) ||
              date.getMonth() !== Number(month) - 1 ||
              date.getDate() !== Number(day)
            )
              return;
            const key = format(date, "yyyy-MM-dd");
            const name = holiday.holiday || "Firm holiday";
            mappedHolidays[key] = mappedHolidays[key]
              ? `${mappedHolidays[key]}, ${name}`
              : name;
          });
        }
        if (!controller.signal.aborted) {
          setFirmHolidays({ firmId, dates: mappedHolidays });
        }
      } catch (error) {
        if (error.name !== "AbortError")
          console.error("Error fetching firm holidays:", error);
      }
    };
    getHolidays();
    return () => controller.abort();
  }, [firmId, username, password]);

  const currentYear = new Date().getFullYear();
  const [years, setYears] = useState(currentYear.toString());
  const currentMonth = new Date().getMonth() + 1;
  const [months, setMonths] = useState(currentMonth.toString());
  const [department, setDepartment] = useState("");
  const selectedMonthHolidays = Object.entries(holidayDates)
    .filter(([date]) =>
      date.startsWith(`${years}-${String(months).padStart(2, "0")}-`),
    )
    .sort(([first], [second]) => first.localeCompare(second));

  const isSecondSaturday = (date) =>
    date.getDay() === 6 && date.getDate() >= 8 && date.getDate() <= 14;

  const generateMonthDates = (year, month) => {
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);
    const dates = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      dates.push(currentDate);
      currentDate = addDays(currentDate, 1);
    }

    return dates;
  };
  useEffect(() => {
    const year = parseInt(years);
    const month = parseInt(months);
    const generatedDates = generateMonthDates(year, month);
    setDates(generatedDates);
  }, [years, months]);

  const generateMonthHeaders = (year, month) => {
    const dates = generateMonthDates(year, month);

    const date = new Date(years, months - 1, 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const datess = dates.length;

    return dates.map((date) => (
      <th
        key={format(date, "yyyy-MM-dd")}
        style={{
          position: "sticky",
          top: 0,
          background: "#48A6A7",
          zIndex: 2,
          textAlign: "center",
          fontSize: ".8rem",
          fontWeight: "400",
          color: "#fff",
          padding: ".7rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <span>{format(date, "dd")}</span>
          <input
            type="checkbox"
            title="Mark all employees present"
            checked={isAllVisibleEmployeesPresentOnDate(date)}
            disabled={filteredEmployees.length === 0}
            onChange={(e) => {
              if (e.target.checked) {
                handleMarkAllForDate(date);
              }
            }}
          />
        </div>
      </th>
    ));
  };

  useEffect(() => {
    const updatedHeaders = generateMonthHeaders(
      parseInt(years),
      parseInt(months),
    );
    setTableHeaders(updatedHeaders);
  }, [months, years, filteredEmployees]);

  const [employees, setEmployees] = useState([]);
  const [attendance, setAttendance] = useState({});
  const [attendanceChanges, setAttendanceChanges] = useState([]);
  const isAllVisibleEmployeesPresentOnDate = (date) => {
    if (filteredEmployees.length === 0) {
      return false;
    }

    const dateStr = format(date, "yyyy-MM-dd");
    return filteredEmployees.every((employee) =>
      employee.data.some(
        (entry) =>
          format(new Date(entry.attendance_date), "yyyy-MM-dd") === dateStr &&
          entry.attendance_status === "Y",
      ),
    );
  };

  const handleMarkAllForEmployee = (employee) => {
    const updatedChanges = [...attendanceChanges];
    const updatedEmployees = [...employees];

    dates.forEach((date) => {
      const dateStr = format(date, "yyyy-MM-dd");

      // --- update attendanceChanges ---
      const idx = updatedChanges.findIndex(
        (c) => c.id === employee.employee_code && c.attendance_date === dateStr,
      );

      if (idx === -1) {
        updatedChanges.push({
          id: employee.employee_code,
          firmid: user.firm_id,
          attendance_date: dateStr,
          attendance_status: "Y",
          type: "Attendance",
        });
      } else {
        updatedChanges[idx].attendance_status = "Y";
      }

      // --- update employees state (UI reflect) ---
      const empIndex = updatedEmployees.findIndex(
        (e) => e.employee_code === employee.employee_code,
      );

      if (empIndex !== -1) {
        const dayIndex = updatedEmployees[empIndex].data.findIndex(
          (d) => format(new Date(d.attendance_date), "yyyy-MM-dd") === dateStr,
        );

        if (dayIndex !== -1) {
          updatedEmployees[empIndex].data[dayIndex].attendance_status = "Y";
        } else {
          updatedEmployees[empIndex].data.push({
            attendance_date: dateStr,
            attendance_status: "Y",
          });
        }
      }
    });

    setAttendanceChanges(updatedChanges);
    setEmployees(updatedEmployees);
  };

  const handleMarkAllForDate = (date) => {
    const dateStr = format(date, "yyyy-MM-dd");
    const visibleEmployeeCodes = filteredEmployees.map(
      (employee) => employee.employee_code,
    );

    setAttendanceChanges((prevChanges) => {
      const updatedChanges = [...prevChanges];

      filteredEmployees.forEach((employee) => {
        const idx = updatedChanges.findIndex(
          (change) =>
            change.id === employee.employee_code &&
            change.attendance_date === dateStr,
        );

        if (idx === -1) {
          updatedChanges.push({
            id: employee.employee_code,
            firmid: user.firm_id,
            attendance_date: dateStr,
            attendance_status: "Y",
            type: "Attendance",
          });
        } else {
          updatedChanges[idx].attendance_status = "Y";
        }
      });

      return updatedChanges;
    });

    setEmployees((prevEmployees) =>
      prevEmployees.map((employee) => {
        if (!visibleEmployeeCodes.includes(employee.employee_code)) {
          return employee;
        }

        const updatedData = [...employee.data];
        const dayIndex = updatedData.findIndex(
          (entry) =>
            format(new Date(entry.attendance_date), "yyyy-MM-dd") === dateStr,
        );

        if (dayIndex !== -1) {
          updatedData[dayIndex] = {
            ...updatedData[dayIndex],
            attendance_status: "Y",
          };
        } else {
          updatedData.push({
            attendance_date: dateStr,
            attendance_status: "Y",
          });
        }

        return {
          ...employee,
          data: updatedData,
        };
      }),
    );
  };

  const handleCheckboxChange = (employeeId, day, isChecked) => {
    const updatedChanges = [...attendanceChanges];
    const updatedEmployees = [...employees];
    const dateStr = format(new Date(day), "yyyy-MM-dd");

    const changeIndex = updatedChanges.findIndex(
      (change) =>
        change.id === employeeId && change.attendance_date === dateStr,
    );

    if (isChecked) {
      if (changeIndex === -1) {
        updatedChanges.push({
          id: employeeId,
          firmid: user.firm_id,
          attendance_date: dateStr,
          attendance_status: "Y",
          type: "Attendance",
        });
      } else {
        updatedChanges[changeIndex].attendance_status = "Y";
      }
    } else {
      if (changeIndex === -1) {
        updatedChanges.push({
          id: employeeId,
          firmid: user.firm_id,
          attendance_date: dateStr,
          attendance_status: "N",
          type: "Attendance",
        });
      } else {
        updatedChanges[changeIndex].attendance_status = "N";
      }
    }

    const employeeIndex = updatedEmployees.findIndex(
      (employee) => employee.employee_code === employeeId,
    );
    if (employeeIndex !== -1) {
      const dayIndex = updatedEmployees[employeeIndex].data.findIndex(
        (entry) =>
          format(new Date(entry.attendance_date), "yyyy-MM-dd") === dateStr,
      );
      if (dayIndex !== -1) {
        updatedEmployees[employeeIndex].data[dayIndex].attendance_status =
          isChecked ? "Y" : "N";
      } else {
        updatedEmployees[employeeIndex].data.push({
          attendance_date: dateStr,
          attendance_status: isChecked ? "Y" : "N",
        });
      }
    }

    setAttendanceChanges(updatedChanges);
    setEmployees(updatedEmployees);
  };

  const handleMarkAttendance = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestBody = JSON.stringify({ requests: attendanceChanges });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: requestBody,
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/MarkAttendance`,
        requestOptions,
      );

      const data = await response.json();
      if (data.status === "0") {
        getAttandancedata();
        setAttendanceChanges([]);
      } else {
        swal("Error marking attendance:", data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      swal("Error marking attendance:", error);
      setTransactionLoaderState(false);
    }
  };
  const MarkAttendance = async () => {
    if (!validateForm()) {
      swal("Error", "Please fill in all fields.", "error");
      return;
    }

    const { selectedEmployee, selectedDate, inTime, outTime, status } =
      formData;
    const empid = selectedEmployee.value;
    const firmid = selectedEmployee.firmId;

    const dateObj = new Date(selectedDate);
    const attendanceDate = dateObj.toISOString().split("T")[0];

    const requestBody = {
      requests: [
        {
          id: empid,
          firmid,
          attendance_date: attendanceDate,
          attendance_status: status?.value || "Y",
          type: "Attendance",
          in_time: inTime,
          out_time: outTime,
        },
      ],
    };

    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/MarkAttendance`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();
      if (data.status === "0") {
        getAttandancedata();
        setAttendanceChanges([]);
        setFormData({
          selectedEmployee: null,
          selectedDate: null,
          inTime: "",
          outTime: "",
          status: null,
        });
      } else {
        swal("Error marking attendance:", data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      swal("Error marking attendance:", error);
      setTransactionLoaderState(false);
    }
  };
  const getAttandancedata = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        id: user.firm_id,
        month: months,
        year: years,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetMarkAttendance`,
        requestOptions,
      );

      const data = await res.json();
      if (data.status === "0" || data.status == "1") {
        const updatedAttendance = {};

        const employeesList = data.data;
        const employeesListNew = [];
        const dates = generateMonthDates(years, months);
        const datess = dates.length;
        console.log(datess + "meeeee");

        employeesList.forEach((ee) => {
          const datesNew = [];
          for (let i = 1; i <= datess; i++) {
            let found2 = null;
            ee.data.map((entry) => {
              if (new Date(entry.attendance_date).getDate() == i) {
                found2 = entry;
              }
            });
            if (found2) {
              datesNew.push(found2);
            } else {
              let d2 = new Date(Number(years), Number(months) - 1, i);
              datesNew.push({
                attendance_date: d2,
                attendance_status: "N",
                month: months,
                year: years,
              });
            }
          }
          //  console.log(datesNew);
          ee.data = datesNew;
          console.log(ee);
          employeesListNew.push(ee);
        });

        console.log(employeesListNew);
        setAttendance(updatedAttendance);
        setEmployees(data.data);
      } else {
        swal("Error fetching attendance data:", data.msg);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getDepartmentList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({ firmid: user.firm_id });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployeeDepartment`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setDepartmentData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const openModal = () => {
    setshowcheckmodal(true);
  };

  const closeModal = () => {
    setshowcheckmodal(false);
  };

  useEffect(() => {
    getDepartmentList();
    getAttandancedata();
  }, [months, years]);

  useEffect(() => {
    if (employees.length > 0) {
    }
  }, [employees]);
  console.log(employees);

  useEffect(() => {
    if (department !== "") {
      const filtered = employees.filter(
        (employee) => employee.employee_department === department,
      );
      setFilteredEmployees(filtered);
    } else {
      setFilteredEmployees(employees);
    }
  }, [department, employees]);

  const { accessData } = useContext(GlobalContext);
  useEffect(() => {
    console.log("Access Data:", accessData);
  }, [accessData]);

  //
  const [empdata, setempdata] = useState([]);
  const [formData, setFormData] = useState({
    selectedEmployee: null,
    selectedDate: null,
    inTime: "",
    outTime: "",
    status: null,
  });
  const getEmployeeList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmId: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setempdata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getEmployeeList();
  }, []);
  const handleInputChange = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };
  const employeeOptions = empdata.map((emp) => ({
    value: emp.empid,
    label: `${emp.firstname} ${emp.lastname}`,
    firmId: emp.firm_id,
  }));

  const statusOptions = [
    { value: "Y", label: "Present" },
    { value: "N", label: "Absent" },
  ];
  const validateForm = () => {
    const { selectedEmployee, selectedDate } = formData;
    return selectedEmployee && selectedDate;
  };
  const convertTo12HourFormat = (time24) => {
    if (!time24) return "";
    const [hour, minute] = time24.split(":");
    const h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12;
    return `${hour12}:${minute} ${ampm}`;
  };

  const handleMarkAttendanceType = async (type) => {
    if (!validateForm()) {
      swal("Error", "Please fill in all fields.", "error");
      return;
    }

    const { selectedEmployee, selectedDate, inTime, outTime } = formData;

    const empid = selectedEmployee.value;
    const firmid = selectedEmployee.firmId;

    const dateObj = new Date(selectedDate);
    const year = String(dateObj.getFullYear());
    const month = String(dateObj.getMonth() + 1);
    const date = String(dateObj.getDate());
    const formattedDate = `${year}-${month}-${date}`;

    const requestBody = {
      empid: String(empid),
      date: formattedDate,
      month: month,
      year: year,
      firmid: String(firmid),
      in_time: inTime,
      out_time: outTime,
      // in_time: convertTo12HourFormat(inTime),
      // out_time: convertTo12HourFormat(outTime),
      type: String(type),
    };

    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/MakHalfDay`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const responseData = await response.json();

      if (
        responseData.status === "0" &&
        responseData.result[0].result === "Y"
      ) {
        swal("Success", responseData.result[0].message, "success");
        getAttandancedata();
        setFormData({
          selectedEmployee: null,
          selectedDate: null,
          inTime: "",
          outTime: "",
          status: null,
        });
      } else {
        swal("Error", responseData.msg || "Failed to mark attendance", "error");
      }
    } catch (error) {
      console.error("Error marking attendance:", error);
      swal("Error", "An error occurred while marking attendance.", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const [showPreview, setShowPreview] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredPreviewEmployees = filteredEmployees.filter((employee) =>
    employee.employee_name?.toLowerCase()?.includes(searchTerm?.toLowerCase()),
  );
  const monthLabel = format(
    new Date(Number(years), Number(months) - 1, 1),
    "MMMM yyyy",
  );
  const moveMonth = (offset) => {
    const next = new Date(Number(years), Number(months) - 1 + offset, 1);
    setYears(String(next.getFullYear()));
    setMonths(String(next.getMonth() + 1));
  };
  const canEdit = accessData?.some((module) =>
    module.data?.some(
      (role) => role.role_name === "Add Attendance" && role.access === "Y",
    ),
  );
  const canCheck = accessData?.some((module) =>
    module.data?.some(
      (role) => role.role_name === "Attendance Check" && role.access === "Y",
    ),
  );
  const legends = [
    ["present", "Present"],
    ["half", "Half Day"],
    ["holiday", "Public Holiday"],
    ["saturday", "2nd Saturday"],
    ["sunday", "Sunday Off"],
    ["empty", "No Entry"],
    ["late", "Late"],
    ["pl", "PL"],
    ["sl", "SL"],
    ["wfh", "WFH"],
  ];
  return (
    <div className="attendance-management">
      <BulkAttendanceHr
        show={showcheckmodal}
        closeModal={closeModal}
        months={months}
      />
      <header className="attendance-heading">
        <div className="mt-4">
          {/* <div className="attendance-breadcrumb"><FaHome /> HR &amp; People <FiChevronRight /> <strong>Attendance Management</strong></div> */}
          <h1>Attendance Management</h1>
          {/* <p>Track, manage and update employee attendance for {monthLabel}.</p> */}
        </div>
        <div className="attendance-heading-controls">
          <div className="attendance-holidays">
            {selectedMonthHolidays.map(([date, occasion]) => (
              <span key={date}>
                <FiCalendar /> {format(new Date(`${date}T00:00:00`), "dd MMM")}:{" "}
                {occasion}
              </span>
            ))}
          </div>
          <div className="attendance-month-nav">
            <button aria-label="Previous month" onClick={() => moveMonth(-1)}>
              <FiChevronLeft />
            </button>
            <button
              className="attendance-month-current"
              aria-label="Next month"
              onClick={() => moveMonth(1)}
            >
              <FiCalendar /> {monthLabel} <FiChevronRight />
            </button>
            <button
              onClick={() => {
                setYears(String(currentYear));
                setMonths(String(currentMonth));
              }}
            >
              Today
            </button>
          </div>
        </div>
      </header>
      <Form
        className="attendance-entry-card"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="attendance-fields">
          <Form.Group>
            <Form.Label>Select Employee</Form.Label>
            <Select
              inputId="attendance-employee"
              aria-label="Select Employee"
              classNamePrefix="attendance-select"
              options={employeeOptions}
              value={formData.selectedEmployee}
              onChange={(value) => handleInputChange("selectedEmployee", value)}
              placeholder="All Employees"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Select
              inputId="attendance-status"
              aria-label="Status"
              classNamePrefix="attendance-select"
              options={statusOptions}
              value={formData.status}
              onChange={(value) => handleInputChange("status", value)}
              placeholder="All Status"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="attendance-date">Select Date</Form.Label>
            <Form.Control
              id="attendance-date"
              type="date"
              value={formData.selectedDate || ""}
              onChange={(e) =>
                handleInputChange("selectedDate", e.target.value)
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="attendance-in">In Time</Form.Label>
            <div className="attendance-time">
              <FiClock />
              <Form.Control
                id="attendance-in"
                type="time"
                value={formData.inTime}
                onChange={(e) => handleInputChange("inTime", e.target.value)}
              />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="attendance-out">Out Time</Form.Label>
            <div className="attendance-time">
              <FiClock />
              <Form.Control
                id="attendance-out"
                type="time"
                value={formData.outTime}
                onChange={(e) => handleInputChange("outTime", e.target.value)}
              />
            </div>
          </Form.Group>
        </div>
        <div className="attendance-actions">
          <div className="attendance-action-group">
            <button
              className="attendance-button primary"
              onClick={MarkAttendance}
            >
              <FiCheck /> Mark Attendance
            </button>
            <button
              className="attendance-button half-button"
              onClick={() => handleMarkAttendanceType("HalfDay")}
            >
              <HalfDayClockIcon /> Mark Half Day
            </button>
            <button
              className="attendance-button late-button"
              onClick={() => handleMarkAttendanceType("LATE")}
            >
              <FiClock /> Mark Late
            </button>
          </div>
          <div className="attendance-action-group">
            <Link
              className="attendance-button raw-button"
              to="/Hr/raw-attendance"
            >
              <FiFileText /> Raw Attendance
            </Link>
            <button
              className="attendance-button save-button"
              onClick={handleMarkAttendance}
            >
              <FiSave /> Save Attendance
            </button>
          </div>
        </div>
      </Form>
      <div className="attendance-toolbar">
        <div className="attendance-filters">
          <select
            aria-label="Year"
            value={years}
            onChange={(e) => setYears(e.target.value)}
          >
            {Array.from(new Set([2024, 2025, 2026, 2027, Number(years)]))
              .sort()
              .map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
          </select>
          <select
            aria-label="Month"
            value={months}
            onChange={(e) => setMonths(e.target.value)}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i} value={i + 1}>
                {format(new Date(2026, i, 1), "MMMM")}
              </option>
            ))}
          </select>
          <select
            aria-label="Department"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          >
            <option value="">All Departments</option>
            {departmentData.map((dept) => (
              <option key={dept.id} value={dept.cat1}>
                {dept.cat1}
              </option>
            ))}
          </select>
          <button
            className="attendance-button outline"
            onClick={openModal}
            disabled={!canCheck}
          >
            <FiSearch /> Check Attendance
          </button>
          <button
            className="attendance-button outline preview"
            onClick={() => setShowPreview(true)}
          >
            <FiEye /> Preview
          </button>
        </div>
        <div className="attendance-legend">
          {legends.map(([type, label]) => (
            <span key={type}>
              <i className={type} aria-hidden="true">
                {type === "late" && <FiClock />}
                {type === "half" && <HalfDayClockIcon />}
                {type === "pl" && <FaPlane />}
                {type === "sl" && <FaBriefcaseMedical />}
                {type === "wfh" && <FaHome />}
              </i>
              {label}
            </span>
          ))}
        </div>
      </div>
      <div className="attendance-grid-scroll">
        <table className="attendance-grid">
          <thead>
            <tr>
              {/* <th className="attendance-index">#</th> */}
              <th className="attendance-employee-col">Employee</th>
              {dates.map((date) => (
                <th
                  key={format(date, "yyyy-MM-dd")}
                  className={
                    isSunday(date)
                      ? "sunday"
                      : date.getDay() === 6
                        ? "saturday"
                        : ""
                  }
                >
                  <strong>{format(date, "dd")}</strong>
                  <span>{format(date, "EEE")}</span>
                  <input
                    className="attendance-mark-all"
                    type="checkbox"
                    aria-label={`Mark all employees present on ${format(date, "dd MMM yyyy")}`}
                    title="Mark all employees present"
                    checked={isAllVisibleEmployeesPresentOnDate(date)}
                    disabled={filteredEmployees.length === 0}
                    onChange={(e) => {
                      if (e.target.checked) handleMarkAllForDate(date);
                    }}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredEmployees.map((employee, index) => (
              <tr key={employee.employee_code || employee.id}>
                {/* <td className="attendance-index">{index + 1}</td> */}
                <td className="attendance-employee-col">
                  <div className="attendance-employee">
                    <input
                      className="attendance-mark-all"
                      type="checkbox"
                      aria-label={`Mark all days present for ${employee.employee_name}`}
                      title="Mark all days present"
                      checked={
                        dates.length > 0 &&
                        dates.every((date) =>
                          employee.data.some(
                            (entry) =>
                              format(
                                new Date(entry.attendance_date),
                                "yyyy-MM-dd",
                              ) === format(date, "yyyy-MM-dd") &&
                              entry.attendance_status === "Y",
                          ),
                        )
                      }
                      onChange={(e) => {
                        if (e.target.checked)
                          handleMarkAllForEmployee(employee);
                      }}
                    />
                    <span className="attendance-avatar">
                      {employee.employee_name
                        ?.split(/\s+/)
                        .filter(Boolean)
                        .slice(0, 2)
                        .map((name) => name[0])
                        .join("")}
                    </span>
                    <div>
                      <strong>{employee.employee_name}</strong>
                      <span>
                        {employee.employee_designation ||
                          employee.designation ||
                          employee.employee_department}
                      </span>
                    </div>
                  </div>
                </td>
                {dates.map((date) => {
                  const key = format(date, "yyyy-MM-dd");
                  const entries = employee.data.filter(
                    (entry) =>
                      format(new Date(entry.attendance_date), "yyyy-MM-dd") ===
                      key,
                  );
                  const present = entries.some(
                    (entry) => entry.attendance_status === "Y",
                  );
                  const special = entries.find((entry) =>
                    ["LATE", "HalfDay", "SL", "PL", "WFH"].includes(entry.type),
                  );
                  const holiday = holidayDates[key];
                  const off = isSunday(date) || isSecondSaturday(date);
                  const type = holiday
                    ? "holiday"
                    : isSunday(date)
                      ? "sunday"
                      : isSecondSaturday(date)
                        ? "saturday"
                        : special?.type === "LATE"
                          ? "late"
                          : special?.type === "HalfDay"
                            ? "half"
                            : present
                              ? "present"
                              : "empty";
                  return (
                    <td
                      key={key}
                      className={type}
                      title={
                        holiday ||
                        special?.type ||
                        (off ? "Weekly off" : present ? "Present" : "No entry")
                      }
                    >
                      {holiday ? (
                        <strong className="attendance-day-label">PH</strong>
                      ) : off ? (
                        <strong className="attendance-day-label">WO</strong>
                      ) : (
                        <div className="attendance-day">
                          {canEdit ? (
                            <label className={`attendance-check ${type}`}>
                              <input
                                aria-label={`Mark ${employee.employee_name} present on ${format(date, "dd MMM yyyy")}`}
                                type="checkbox"
                                checked={present}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    employee.employee_code,
                                    date,
                                    e.target.checked,
                                  )
                                }
                              />
                              <span>
                                {type === "late" ? (
                                  <FiClock />
                                ) : type === "half" ? (
                                  <HalfDayClockIcon />
                                ) : present ? (
                                  <FiCheck />
                                ) : (
                                  ""
                                )}
                              </span>
                            </label>
                          ) : (
                            (present || special) && (
                              <span
                                className={`attendance-status-icon ${type}`}
                              >
                                {type === "late" ? (
                                  <FiClock />
                                ) : type === "half" ? (
                                  <HalfDayClockIcon />
                                ) : (
                                  <FiCheck />
                                )}
                              </span>
                            )
                          )}
                          {special &&
                            ["SL", "PL", "WFH"].includes(special.type) && (
                              <span
                                className={`attendance-special-badge ${special.type.toLowerCase()}`}
                                title={
                                  special.type === "WFH"
                                    ? "Work from home"
                                    : special.type === "SL"
                                      ? "Sick leave"
                                      : "Paid leave"
                                }
                              >
                                {special.type === "WFH" ? (
                                  <FaHome aria-hidden="true" />
                                ) : special.type === "SL" ? (
                                  <FaBriefcaseMedical aria-hidden="true" />
                                ) : (
                                  <FaPlane aria-hidden="true" />
                                )}
                                <b>{special.type}</b>
                              </span>
                            )}
                          {entries.some(
                            (entry) => entry.in_time || entry.out_time,
                          ) ? (
                            entries
                              .filter(
                                (entry) => entry.in_time || entry.out_time,
                              )
                              .map((entry, i) => (
                                <div className="attendance-times" key={i}>
                                  {(entry.in_time ||
                                    !["SL", "PL", "WFH"].includes(
                                      special?.type,
                                    )) && <span>{entry.in_time || "--"}</span>}
                                  {(entry.out_time ||
                                    !["SL", "PL", "WFH"].includes(
                                      special?.type,
                                    )) && <span>{entry.out_time || "--"}</span>}
                                </div>
                              ))
                          ) : !["SL", "PL", "WFH"].includes(special?.type) ? (
                            <span className="attendance-no-time">--</span>
                          ) : null}
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        {!filteredEmployees.length && (
          <div className="attendance-empty-state">
            No attendance records for the selected month and department.
          </div>
        )}
      </div>
      {showPreview && (
        <Modal
          show={showPreview}
          onHide={() => setShowPreview(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "1.2rem" }}>
              Attendance Preview
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Search Input */}
            <Form.Group className="mb-2">
              <Form.Control
                type="text"
                placeholder="Search Employee..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "20vw" }}
              />
            </Form.Group>

            <div
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <table className="table table-bordered">
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 2,
                  }}
                >
                  <tr>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Employee
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total Present
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total Absent
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      SL Balance
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      PL Balance
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total used PL
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total used SL
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total WFH
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total HalfDay
                    </th>
                    {tableHeaders}
                  </tr>
                </thead>
                <tbody>
                  {filteredPreviewEmployees.map((employee) => {
                    const totalPresent = employee.data.filter(
                      (entry) => entry.attendance_status === "Y",
                    ).length;
                    const totalAbsent = dates.length - totalPresent;

                    const totalPL = employee.data.filter(
                      (entry) => entry.type === "PL",
                    ).length;

                    const totalSL = employee.data.filter(
                      (entry) => entry.type === "SL",
                    ).length;

                    const totalWFH = employee.data.filter(
                      (entry) => entry.type === "WFH",
                    ).length;

                    const totalHalfday = employee.data.filter(
                      (entry) => entry.type === "HalfDay",
                    ).length;
                    return (
                      <tr key={employee.id}>
                        <td style={{ fontSize: ".9rem", fontWeight: "400" }}>
                          {employee.employee_name}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "green",
                          }}
                        >
                          {totalPresent}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "red",
                          }}
                        >
                          {totalAbsent}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "green",
                          }}
                        >
                          {employee.sl_bal}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "green",
                          }}
                        >
                          {employee.pl_bal}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "blue",
                          }}
                        >
                          {totalPL}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "orange",
                          }}
                        >
                          {totalSL}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "purple",
                          }}
                        >
                          {totalWFH}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "purple",
                          }}
                        >
                          {totalHalfday}
                        </td>
                        {dates.map((date, i) => (
                          <td key={i} style={{ textAlign: "center" }}>
                            {employee.data.some(
                              (entry) =>
                                format(
                                  new Date(entry.attendance_date),
                                  "yyyy-MM-dd",
                                ) === format(date, "yyyy-MM-dd") &&
                                entry.attendance_status === "Y",
                            )
                              ? "✔️"
                              : "❌"}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default AttandancecalendraHR;
